import styled from '@emotion/styled';

const Column = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;

  ${(props) =>
    props.sm6 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  `}

  ${(props) =>
    props.sm9 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
  `}

  ${(props) =>
    props.sm3 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
  `}

  ${(props) =>
    props.sm2 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
  `}

  ${(props) =>
    props.sm4 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  `}

  ${(props) =>
    props.sm8 &&
    `
    @media (min-width: 576px) {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
  `}

  ${(props) =>
    props.md2 &&
    `
    @media (min-width: 768px) { 
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
  `}

  ${(props) =>
    props.md3 &&
    `
    @media (min-width: 768px) { 
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%
    }
  `}

  ${(props) =>
    props.md6 &&
    `
    @media (min-width: 768px) { 
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  `}

  ${(props) =>
    props.md9 &&
    `
    @media (min-width: 768px) { 
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
  `}
`;

export { Column };
